import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=17611f6a&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17611f6a')) {
      api.createRecord('17611f6a', component.options)
    } else {
      api.reload('17611f6a', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=17611f6a&", function () {
      api.rerender('17611f6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2QJr7G3fb1Rv2/JS/imageCarousel.vue"
export default component.exports